const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const {
  DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST,
  DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE,
  GET_GLOBAL_DESTINATION_SERVICES_REQUEST,
  GET_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  GET_GLOBAL_DESTINATION_SERVICES_FAILURE,
  POST_GLOBAL_DESTINATION_SERVICES_REQUEST,
  POST_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  POST_GLOBAL_DESTINATION_SERVICES_FAILURE,
  GET_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  GET_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  POST_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  POST_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  GET_GLOBAL_INFO_REQUEST,
  GET_GLOBAL_INFO_SUCCESS,
  GET_GLOBAL_INFO_FAILURE,
  POST_GLOBAL_INFO_REQUEST,
  POST_GLOBAL_INFO_SUCCESS,
  POST_GLOBAL_INFO_FAILURE,
  UPDATE_GLOBAL_INFO_REQUEST,
  UPDATE_GLOBAL_INFO_SUCCESS,
  UPDATE_GLOBAL_INFO_FAILURE,
  UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST,
  UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE,
  GET_ASSIGNMENT_TRIPS_REQUEST,
  GET_ASSIGNMENT_TRIPS_SUCCESS,
  GET_ASSIGNMENT_TRIPS_FAILURE,
  GET_ASSIGNMENT_TRIP_FAILURE,
  GET_ASSIGNMENT_TRIP_REQUEST,
  GET_ASSIGNMENT_TRIP_SUCCESS,
  UPSERT_ASSIGNMENT_TRIPS_FAILURE,
  UPSERT_ASSIGNMENT_TRIPS_REQUEST,
  UPSERT_ASSIGNMENT_TRIPS_SUCCESS,
  DELETE_ASSIGNMENT_TRIPS_REQUEST,
  DELETE_ASSIGNMENT_TRIPS_SUCCESS,
  DELETE_ASSIGNMENT_TRIPS_FAILURE,
  GET_ASSIGNMENT_EXTENSIONS_REQUEST,
  GET_ASSIGNMENT_EXTENSIONS_SUCCESS,
  GET_ASSIGNMENT_EXTENSIONS_FAILURE,
  POST_ASSIGNMENT_EXTENSIONS_REQUEST,
  POST_ASSIGNMENT_EXTENSIONS_SUCCESS,
  POST_ASSIGNMENT_EXTENSIONS_FAILURE,
  UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST,
  UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS,
  UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE,
  DELETE_ASSIGNMENT_EXTENSIONS_REQUEST,
  DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS,
  DELETE_ASSIGNMENT_EXTENSIONS_FAILURE,
  GET_GLOBAL_ASSIGNMENT_FAILURE,
  GET_GLOBAL_ASSIGNMENT_REQUEST,
  GET_GLOBAL_ASSIGNMENT_SUCCESS,
  POST_GLOBAL_ASSIGNMENT_FAILURE,
  POST_GLOBAL_ASSIGNMENT_REQUEST,
  POST_GLOBAL_ASSIGNMENT_SUCCESS,
  UPDATE_GLOBAL_ASSIGNMENT_FAILURE,
  UPDATE_GLOBAL_ASSIGNMENT_REQUEST,
  UPDATE_GLOBAL_ASSIGNMENT_SUCCESS,
  GET_GLOBAL_PROPERTY_MANAGEMENT_REQUEST,
  GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS,
  GET_GLOBAL_PROPERTY_MANAGEMENT_FAILURE,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_REQUEST,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_FAILURE,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE,
  PUT_GLOBAL_VISA_VACCINE_REQUEST,
  PUT_GLOBAL_VISA_VACCINE_SUCCESS,
  PUT_GLOBAL_VISA_VACCINE_FAILURE
} = require('../types/globalTypes');
/* Global Requests */

export const getGlobalInfo = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_INFO_REQUEST, GET_GLOBAL_INFO_SUCCESS, GET_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/global`,
      method: 'GET'
    }
  };
};

export const postGlobalInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_INFO_REQUEST, POST_GLOBAL_INFO_SUCCESS, POST_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/global/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_INFO_REQUEST, UPDATE_GLOBAL_INFO_SUCCESS, UPDATE_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/global/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getAssignmentTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_TRIPS_REQUEST, GET_ASSIGNMENT_TRIPS_SUCCESS, GET_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${serviceId}/globalTrips`,
      method: 'GET'
    }
  };
};

export const getAssignmentTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_TRIP_REQUEST, GET_ASSIGNMENT_TRIP_SUCCESS, GET_ASSIGNMENT_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${tripId}/globalTrips`,
      method: 'GET'
    }
  };
};

export const upsertAssignmentTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_ASSIGNMENT_TRIPS_REQUEST, UPSERT_ASSIGNMENT_TRIPS_SUCCESS, UPSERT_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalTrips/${serviceId}`,
      method: 'POST',
      payload: values
    }
  };
};

export const deleteAssignmentTrip = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_ASSIGNMENT_TRIPS_REQUEST, DELETE_ASSIGNMENT_TRIPS_SUCCESS, DELETE_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/globalTrips`,
      method: 'DELETE'
    }
  };
};

export const getAssignmentExtensions = assignmentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_EXTENSIONS_REQUEST, GET_ASSIGNMENT_EXTENSIONS_SUCCESS, GET_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${assignmentId}/globalExtensions`,
      method: 'GET'
    }
  };
};

export const postAssignmentExtension = (values, authId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_ASSIGNMENT_EXTENSIONS_REQUEST, POST_ASSIGNMENT_EXTENSIONS_SUCCESS, POST_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalExtensions`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAssignmentExtension = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST, UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS, UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalExtensions`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAssignmentExtension = (fileId, assId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_ASSIGNMENT_EXTENSIONS_REQUEST, DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS, DELETE_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/globalExtensions/${assId}`,
      method: 'DELETE'
    }
  };
};

export const getGlobalAssignment = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_ASSIGNMENT_REQUEST, GET_GLOBAL_ASSIGNMENT_SUCCESS, GET_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment/${authId}`,
      method: 'GET'
    }
  };
};

export const postGlobalAssignment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_ASSIGNMENT_REQUEST, POST_GLOBAL_ASSIGNMENT_SUCCESS, POST_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment/`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalAssignment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_ASSIGNMENT_REQUEST, UPDATE_GLOBAL_ASSIGNMENT_SUCCESS, UPDATE_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment/`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getGlobalPropertyManagementInfo = (authId, globalId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_PROPERTY_MANAGEMENT_REQUEST, GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS, GET_GLOBAL_PROPERTY_MANAGEMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt`,
      method: 'GET'
    }
  };
};

export const updateGlobalPropertyManagementHost = (authId, globalId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_REQUEST,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/hosts`,
      method: 'PUT',
      payload: values
    }
  };
};

export const createGlobalPropertyManagementHome = (authId, globalId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalPropertyManagementHome = (authId, globalId, homeId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes/${homeId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalPropertyManagementHome = (authId, globalId, homeId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST,
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes/${homeId}`,
      method: 'DELETE'
    }
  };
};

export const createGlobalPropertyManagementHomeTenant = (authId, globalId, homeId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
        POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes/${homeId}/tenants`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalPropertyManagementHomeTenant = (authId, globalId, homeId, tenantId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
        PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes/${homeId}/tenants/${tenantId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalPropertyManagementHomeTenant = (authId, globalId, homeId, tenantId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST,
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
        DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/propertyMgnt/homes/${homeId}/tenants/${tenantId}`,
      method: 'DELETE'
    }
  };
};

export const updateGlobalVisaAndVaccine = (authId, globalId, familyMemberId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_GLOBAL_VISA_VACCINE_REQUEST, PUT_GLOBAL_VISA_VACCINE_SUCCESS, PUT_GLOBAL_VISA_VACCINE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/family/${familyMemberId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalLanguageTraining = (authId, globalId, landId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST, DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS, DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/lang/${landId}`,
      method: 'DELETE'
    }
  };
};

export const getGlobalInternationalSchooling = (authId, globalId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/intl`,
      method: 'GET'
    }
  };
};

export const postGlobalInternationalSchooling = (authId, globalId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/intl`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalInternationalSchooling = (authId, globalId, intlId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/intl/${intlId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalInternationalSchooling = (authId, globalId, intlId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/intl/${intlId}`,
      method: 'DELETE'
    }
  };
};

export const deleteGlobalDestinationServices = (authId, globalId, destId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST,
        DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
        DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/dest/${destId}`,
      method: 'DELETE'
    }
  };
};

export const getGlobalDestinationServices = (authId, globalId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_DESTINATION_SERVICES_REQUEST, GET_GLOBAL_DESTINATION_SERVICES_SUCCESS, GET_GLOBAL_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/dest`,
      method: 'GET'
    }
  };
};

export const postGlobalDestinationServices = (authId, globalId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_DESTINATION_SERVICES_REQUEST, POST_GLOBAL_DESTINATION_SERVICES_SUCCESS, POST_GLOBAL_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/dest`,
      method: 'POST',
      payload: values
    }
  };
};

export const getGlobalLanguageTraining = (authId, globalId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_LANGUAGE_TRAINING_REQUEST, GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS, GET_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/lang`,
      method: 'GET'
    }
  };
};

export const postGlobalLanguageTraining = (authId, globalId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_LANGUAGE_TRAINING_REQUEST, POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS, POST_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/lang`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalLanguageTraining = (authId, globalId, langId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST, UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS, UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/lang/${langId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateGlobalDestinationServices = (authId, globalId, destId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST,
        UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
        UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global/${globalId}/dest/${destId}`,
      method: 'PUT',
      payload: values
    }
  };
};
